import { createPublicRuntime } from './core/app';

const runtime = createPublicRuntime(document);

runtime.boot().catch((error) => {
  console.error(
    '[quaom-public] boot failed',
    error instanceof Error ? error.message : String(error),
  );
});

window.addEventListener('pagehide', () => runtime.destroy(), { once: true });
